import Entity from '@/models/entities/Entity';

export class QuantityBreak implements Entity {
  public id: number = 0;
  public from: number = 1;
  public to: number = 10;

  constructor(initData: Partial<QuantityBreak>) {
    Object.assign(this, initData);
  }
}
